import { useState, useCallback } from 'react';

interface UseSpeechSynthesisOptions {
	volume?: number;
	rate?: number;
	pitch?: number;
	lang?: string;
}

export const useSpeechSynthesis = (options: UseSpeechSynthesisOptions = {}) => {
	const [isSpeaking, setIsSpeaking] = useState(false);
	const [isPaused, setIsPaused] = useState(false);

	const speak = useCallback((text: string) => {
		// Detener cualquier síntesis de voz en curso
		window.speechSynthesis.cancel();

		// Crear una nueva instancia de SpeechSynthesisUtterance
		const utterance = new SpeechSynthesisUtterance(text);

		// Configurar opciones
		utterance.volume = options.volume ?? 1;
		utterance.rate = options.rate ?? 1;
		utterance.pitch = options.pitch ?? 1;
		utterance.lang = options.lang ?? 'es-ES';

		// Manejar eventos
		utterance.onstart = () => {
			setIsSpeaking(true);
			setIsPaused(false);
		};

		utterance.onend = () => {
			setIsSpeaking(false);
			setIsPaused(false);
		};

		// Hablar
		window.speechSynthesis.speak(utterance);

		return utterance;
	}, [options]);

	const pause = useCallback(() => {
		window.speechSynthesis.pause();
		setIsPaused(true);
	}, []);

	const resume = useCallback(() => {
		window.speechSynthesis.resume();
		setIsPaused(false);
	}, []);

	const cancel = useCallback(() => {
		window.speechSynthesis.cancel();
		setIsSpeaking(false);
		setIsPaused(false);
	}, []);

	return {
		speak,
		pause,
		resume,
		cancel,
		isSpeaking,
		isPaused
	};
};